import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import usePagination from 'modules/core/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { CreatePermissionContext } from 'modules/employees/components/EmployeesList/components/_ListEmployees/CreatePermissionContext'
import type Employee from 'modules/employees/store/models/Employee'

import GroupsList from './_GroupsList'
import Item from './_Item'

interface Props {
  canBulkEdit: boolean
  employees: Employee[]
  groups?: any
  isGroupFilter?: boolean
  selectedEmployeesIds: number[]
  onSelectEmployee: (employee: Employee, value: boolean) => void
  contractVersions: ContractVersions
}

const Body = ({
  canBulkEdit,
  employees,
  groups,
  isGroupFilter,
  selectedEmployeesIds,
  onSelectEmployee,
  contractVersions,
}: Props) => {
  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: employees,
  })

  const canCreateEmployee = React.useContext(CreatePermissionContext).authorization
  const colSpan = canCreateEmployee ? 7 : 6

  if (!employees.length) {
    return (
      <Table.Body>
        <Table.Blank colSpan={colSpan} text={i18n.t('employees.no_employees_found')} />
      </Table.Body>
    )
  }

  if (isGroupFilter) {
    return (
      <>
        {groups ? (
          <GroupsList
            canBulkEdit={canBulkEdit}
            items={groups}
            selectedEmployeesIds={selectedEmployeesIds}
            onSelectEmployee={onSelectEmployee}
            contractVersions={contractVersions}
          />
        ) : (
          <Table.Body>
            <Table.Blank colSpan={colSpan} text={i18n.t('employees.no_employees_found')} />
          </Table.Body>
        )}
      </>
    )
  }

  return (
    <Table.BodyWithInfiniteScroll
      page={page}
      loadMore={loadMore}
      hasMore={hasMore}
      colSpan={colSpan}
    >
      {paginatedItems.map((employee, index) => (
        <Item
          canBulkEdit={canBulkEdit}
          position={index}
          key={employee.id}
          employee={employee}
          selectedEmployeesIds={selectedEmployeesIds}
          onSelectEmployee={onSelectEmployee}
          contractVersions={contractVersions}
        />
      ))}
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(Body)
